import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';

import css from './SubscriptionPage.css';

const getIncluded = (included = [], type, id) => {
  return included.find(i => i.type === type && i.id.uuid === id);
}

export const SubscriptionPageComponent = props => {
  const { intl, params: { id } } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    let aborted = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const res = await dispatch(loadData({ id })); // thunk zwraca Promise z .then(res)
        if (aborted) return;
        const data = res?.data?.data || res?.data || res;
        const included = res?.data?.included || [];
        setSubscription({
          ...data,
          provider: getIncluded(included, 'provider', data.relationships.provider.data.id.uuid),
          listing: getIncluded(included, 'subscription-listing', data.relationships.listing.data.id.uuid),
        })
      } catch (e) {
        if (!aborted) setError(e?.message || 'Nie udało się pobrać subskrypcji');
      } finally {
        if (!aborted) setLoading(false);
      }
    }

    run();
    return () => { aborted = true; };
  }, [dispatch, id]);
  return (
    <Page
      title={intl.formatMessage({ id: 'SubscriptionPage.title' }, { title: "No title" })}
      scrollingDisabled={() => { }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.container}>
            <h1 className={css.pageTitle}>Subskrypcja</h1>

            {loading && (
              <div className={css.loadingBox}>Ładowanie subskrypcji…</div>
            )}

            {!loading && error && (
              <div className={css.errorBox}>{error}</div>
            )}
            {console.log(subscription)}
            {!loading && !error && (
              <div className={css.card}>
                <div className={css.header}>
                  <img
                    src="https://picsum.photos/120"
                    alt={subscription?.listing?.attributes?.title}
                    className={css.thumb}
                  />
                  <div className={css.info}>
                    <div className={css.title}>{subscription?.listing?.attributes?.title}</div>
                    <div className={css.shop}>{subscription?.provider?.attributes?.name}</div>
                  </div>
                </div>
                <div>
                  {formatMoney(intl, subscription.attributes.monthlyPrice)} / miesiąc
                </div>
                <div>
                  Status anulowana / w trakcie / zakonczona 
                </div>
                <div>
                  Tu będzie data kolejnej płatności
                </div>
                <div>
                  {
                    subscription.attributes.transitions.filter(t => t.code === 'payment').map(t => (
                      <div>{t.createdAt}</div>
                    ))
                  }
                </div>
              </div>
            )}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter className={css.footer}>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const SubscriptionPage = compose(
  withRouter,
  injectIntl
)(SubscriptionPageComponent);

const loadData = params => (dispatch, getState, sdk) => {
  console.log(params)
  return sdk.newSdk.subscriptions.show({ id: params.id, include: ['listing', 'provider', 'listing.images'] })
    .then((res) => {
      return res;
    })
    .catch(e => {
      console.error(e, 'loading-subscription-failed', { subscription: params.id });
    });
};

export default SubscriptionPage;
